import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Graphql} from './graphql';
import {DepartmentDto} from '../dto/department-dto';
import {
  createDepartment,
  removeDepartment,
  retrieveDepartmentById,
  retrieveDepartmentsByCompanyId,
  retrieveEligibleParentDepartments,
  updateDepartment
} from '../graphql/department.graphql';

@Injectable({
  providedIn: 'root'
})
export class Department extends Graphql {

  public createDepartment(department: DepartmentDto, fields: string[] = ['id']): Observable<DepartmentDto> {
    return this.mutation<DepartmentDto>(createDepartment(fields), {department: department}, 'createDepartment');
  }

  public updateDepartment(
    department: DepartmentDto,
    fields: string[] = ['id'],
  ): Observable<DepartmentDto> {
    return this.mutation<DepartmentDto>(
      updateDepartment(fields),
      {department},
      'updateDepartment',
    );
  }

  public retrieveDepartmentsByCompanyId(companyId: string, fields: string[] = ['id']): Observable<DepartmentDto[]> {
    return this.query<DepartmentDto[]>(retrieveDepartmentsByCompanyId(fields), {companyId: companyId}, 'retrieveDepartmentsByCompanyId');
  }

  public retrieveEligibleParentDepartments(currentDepartmentId: string | null, companyId: string, fields: string[] = ['id']): Observable<DepartmentDto[]> {
    return this.query<DepartmentDto[]>(retrieveEligibleParentDepartments(fields), {currentDepartmentId: currentDepartmentId, companyId: companyId}, 'retrieveEligibleParentDepartments');
  }

 public removeDepartment(id: string): Observable<boolean> {
    return this.mutation<boolean>(
      removeDepartment(),
      {id},
      'removeDepartment',
    );
}
  

  public retrieveDepartmentById(id: string, companyId: string, fields: string[] = ['id']): Observable<DepartmentDto> {
    return this.query<DepartmentDto>(retrieveDepartmentById(fields), {id: id, companyId: companyId}, 'retrieveDepartmentById');
  }
}
